<template>
  <div class="input-search">
    <img src="../../assets/image/logo.png"  class="logos">
    <input ref="input" type="text" readonly  placeholder="找律师全球通" v-model="searchKey" @focus="onInputSearchFocus" @blur="onInputSearchBlur" @keyup.enter="onEnterKeyup" />
    <i v-show="isShowClear" class="el-icon-close cursor-pointer clear" @click="onClearClick" title="清除"></i>
    <i v-show="isShowSearch" class="el-icon-search search cursor-pointer" @click="onSearchClick" />
  </div>
</template>
<script>
export default {
  name: 'InputSearch',
  props: {
    lockedSearchType: String,
    realTime: Boolean,
    value: String
  },
  data() {
    return {
      isShowClear: false, // 是否输入框聚焦
      isShowSearch: true, // 是否显示查询结果面板
      isShowDetail:false,
      searchKey: '',
      resultType: '' //结果面板点击的类别值
    }
  },
  watch: {
    searchKey() {
      if (this.realTime) {
        this.$emit('input', this.searchKey)
      }
    },
    value() {
      if (this.value !== this.searchKey) {
        this.searchKey = this.value
      }
    }
  },
  methods: {
    //搜索清空
    onClearClick() {
      this.$emit('onClearClick')
      this.isShowClear = false;
      this.isShowSearch=true;
    },
    //回车搜索
    onEnterKeyup() {
      this.$emit('input', this.searchKey)
    },
    //点搜索框搜索
    onSearchClick() {
      this.onEnterKeyup()
      this.$emit('onInputSearchFocus')
      this.isShowClear = true;
      this.isShowSearch=false;
    },
    //输入框获取焦点
    onInputSearchFocus() {
      this.$emit('onInputSearchFocus')
      this.isShowClear = true;
      this.isShowSearch=false;
    },

    //输入框失去焦点
    onInputSearchBlur() {
      // 客户删除完了文本框所有的文本，但是没有按回车提交的时候，重置搜索关键字
      if (!this.searchKey) {
        this.searchKey = this.value
      }
      this.$emit('onInputSearchBlur')
    },
   
    inputFocus() {
      this.$refs.input.focus()
    }
  }

}
</script>
<style lang="less" scoped>
.input-search {
  position: relative;
  display: inline-block;
  width: 100%;
  height: 45px;
  line-height: 45px;
  vertical-align: middle;
  color:#333333;
  .input-search-title {
    display: inline-block;
    width: 90px;
    height: 100%;
    background: rgba(245, 248, 248, 1);
    border-radius: 4px 0px 0px 4px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: rgba(128, 128, 128, 1);
    text-align: center;
    &:hover {
      color: #0097c4;
    }
  }

  .logos{
    width: 38px;
    padding: 3px 3px 3px 5px ;
    margin-bottom: 4px;
    vertical-align: middle;
  }
  input {
    width: calc(100% - 78px);
    margin-left: 15px;
    color: #333333;
    border: none;
    outline: none;
    @include placeholder;
    &.active {
      width: calc(100% - 193px);
    }
  }
  .search {
    position: absolute;
    right: 10px;
    top: 50%;
    transform: translateY(-50%);
    font-size: 20px;
    color: #184580;
  }
  .clear {
    position: absolute;
    right: 30px;
    top: 50%;
    transform: translateY(-50%);
    font-size: 20px;
    &:hover {
      color:#184580;
    }
  }
  .el-icon-close:before {
    color: #808d9b;
  }
}

</style>
